import { render, staticRenderFns } from "./CorpsIntro.vue?vue&type=template&id=64c40f8c&scoped=true"
import script from "./CorpsIntro.vue?vue&type=script&lang=ts"
export * from "./CorpsIntro.vue?vue&type=script&lang=ts"
import style0 from "./CorpsIntro.vue?vue&type=style&index=0&id=64c40f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c40f8c",
  null
  
)

export default component.exports